/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Delegation,
    DelegationFromJSON,
    DelegationFromJSONTyped,
    DelegationToJSON,
} from './';

/**
 * A list of delegations.
 * @export
 * @interface DelegationListAllOf
 */
export interface DelegationListAllOf {
    /**
     * 
     * @type {Array<Delegation>}
     * @memberof DelegationListAllOf
     */
    delegations: Array<Delegation>;
}

export function DelegationListAllOfFromJSON(json: any): DelegationListAllOf {
    return DelegationListAllOfFromJSONTyped(json, false);
}

export function DelegationListAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationListAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'delegations': ((json['delegations'] as Array<any>).map(DelegationFromJSON)),
    };
}

export function DelegationListAllOfToJSON(value?: DelegationListAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'delegations': ((value.delegations as Array<any>).map(DelegationToJSON)),
    };
}


